





































import { Component, Prop, Vue } from 'vue-property-decorator';
import MyAlpacas from '@/components/MyAlpacas.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { Alpaca } from '@/backend/type';
import {
  recycleBatchTransfer,
} from '@/utils/web3';

@Component({
  components: {
    MyAlpacas,
    AlpacaBtn,
  },
})
export default class SelectRecyclePopup extends Vue {
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  public value!: boolean;

  public recycleAlpacas: Alpaca[] = [];

  get account() {
    return this.$store.getters.getAccount;
  }

  get totalSelectdEnergy() {
    return this.$options.filters!.numberToBMK(
      this.recycleAlpacas
        .map((alpaca) => Number(alpaca.total_energy))
        .reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0)
      ,
      2,
    );
  }

  get recycledWool() {
    return 10*this.totalSelectdEnergy;
  }

  get selectedId() {
    return this.recycleAlpacas.map((alpaca) => alpaca.id);
  }

  public changeState(state: boolean) {
    this.$emit('input', state);
  }

  public close() {
    this.changeState(false);
  }

  public toggleAlpaca(alpaca: Alpaca) {
    const index = this.recycleAlpacas.indexOf(alpaca);
    if (index !== -1) {
      this.recycleAlpacas.splice(index, 1);
    } else {
      this.recycleAlpacas.push(alpaca);
    }
  }

  public clickAlpacaCard(alpaca: Alpaca) {
    this.toggleAlpaca(alpaca);
  }

  public handleRecycle() {
    recycleBatchTransfer(this.account, this.selectedId);
    this.close();
  }
}
